<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapGetters('Authentication', [
      'isAuthenticated',
    ]),
  },
  async created() {
    await this.$store.dispatch('Authentication/setLoggedInUser')
    if (this.isAuthenticated) {
      this.$store.dispatch('Favorites/setFavoritesCount')
      this.$store.dispatch('Messages/setUnreadCount')
    }
  },
}
</script>

<style lang="scss">
@import '~nprogress/nprogress.css';
</style>
